import { h } from 'preact';
import { Text } from 'preact-i18n';
import cx from 'classnames';
import { FinanceSpinner } from '../glyphs';
import style from './style';

import Container from '../container';

const INTL_NS = 'company-profile';

export default function Description({ data, hide = false }) {
	if (hide) return null;

	let rows = data && data.rows && data.rows[0];

	if (!rows) {
		return <FinanceSpinner />;
	}

	return (
		<div class={style.description}>
			<Container parent class={style.container} title={<Text id={`${INTL_NS}.description`} />}>
				<div class={cx(!rows.businessSummary && style.dataUnavailable)}>
					{rows.businessSummary || <Text id={`${INTL_NS}.dataUnavailable`} />}
				</div>
			</Container>
		</div>
	);
}
